import type {
  SectionChangeHandler,
  SectionStat,
  SectionType,
} from '@components/SitemapReport/types'
import { getSectionState } from '@components/SitemapReport/utils'
import { Tooltip } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'
import { useCardItem } from './useCardItem'

interface Props {
  section: SectionType
  title: string
  stat: SectionStat
  activeSection: SectionType
  changes: boolean
  comparison: string
  wide?: boolean
  onSectionChange: SectionChangeHandler
}

export const CardItem: React.FC<Props> = ({
  section,
  title,
  stat,
  activeSection,
  changes,
  comparison,
  wide = false,
  onSectionChange,
}) => {
  const { active, deltaActive } = getSectionState(
    section,
    activeSection,
    changes
  )

  const { disabled, totalAmount, handleClick, handleDeltaClick } = useCardItem(
    section,
    stat.count,
    onSectionChange
  )

  const cn = clsJoin(
    css.stat_card,
    wide && css.wide,
    active && css.active,
    disabled && css.disabled
  )

  return (
    <div className={cn} onClick={handleClick}>
      <div className={clsJoin(css.amount, totalAmount && css.total)}>
        {stat.count}
      </div>
      <div className={css.title}>{title}</div>
      {stat.delta && (
        <div className={css.delta_wrap}>
          <Tooltip label={comparison}>
            <button
              className={clsJoin(css.delta, deltaActive && css.delta_active)}
              onClick={handleDeltaClick}
            >
              {stat.delta}
            </button>
          </Tooltip>
        </div>
      )}
    </div>
  )
}
